import styled from "styled-components";

import { helpIconImage } from "../../../utils/staticImages";

export const HelpMenuContainer = styled.div`
	display: flex;
	align-items: center;
`;

export const HelpMenuImage = styled.svg`
	background: url(${helpIconImage}) no-repeat;
	background-size: cover; /* Optionally adjust the background size */
	fill: #2e333e !important;
	height: 24px;
	width: 24px;
	border: none;
	cursor: pointer;
	stroke: #2e333e !important;
	color: #2e333e !important;
	stroke-width: 0;
	background-color: #2e333e;
	border-radius: 50%;
`;

export const HelpMenuText = styled.p`
	margin: 0 4px;
	color: #2e333e;
	cursor: pointer;
`;

export const HelpMenuLabel = styled.div`
	min-width: 200px;
	padding: 12px 0;
	display: flex;
	align-items: center;
	position: relative;
	border-bottom: solid 1px #eaeaee;
`;

export const HelpMenuOverlay = styled.div`
	position: fixed;
	display: block;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 2;
	cursor: pointer;
`;

export const HelpMenuLabelImage = styled.svg<{ $backgroundImage?: string }>`
	stroke: transparent;
	stroke-width: 0px;
	height: 40px;
	padding: 14px;
	border-radius: 5px;
	width: 40px;
	border: none;
	margin-right: 17px;
	background: ${(props) =>
		props.$backgroundImage ? `url(${props.$backgroundImage})` : "none"};
`;

export const HelpImageArrow = styled.svg<{ $background?: string }>`
	background: ${(props) =>
		props.$background ? `url(${props.$background})` : "none"};
	width: 18px;
	height: 18px;
	position: absolute;
	right: 8px;
`;

export const HelpCloseCircle = styled.svg<{ $background?: string }>`
	background: ${(props) =>
		props.$background ? `url(${props.$background})` : "none"};
	height: 24px;
	width: 24px;
	stroke: transparent;
	stroke-width: 0px;

	&:hover {
		background-color: #fff !important;
	}
`;
